import { render, staticRenderFns } from "./WhatsappBalloon.vue?vue&type=template&id=2d54b65d&"
import script from "./WhatsappBalloon.vue?vue&type=script&lang=js&"
export * from "./WhatsappBalloon.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappBalloon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports